import { Box, Grid2, Typography } from "@mui/material"
import { DataNode } from "graphql/types"
import { getImageURL } from "utils/getFileURL"

type ReportNodeImageBoxProps = {
  data: DataNode
  isSmall?: boolean
}

export const ReportNodeImageBox = (props: ReportNodeImageBoxProps) => {
  const { data, isSmall = false } = props

  return (
    <Box>
      {data.image.length === 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ backgroundColor: "red" }}>
            File is missing!
          </Typography>
        </Box>
      )}

      {data.image.length === 1 && !isSmall && (
        <Box sx={{ mb: 2 }}>
          <Box
            component={"img"}
            src={getImageURL(data.image[0])}
            alt={data.image[0]}
            sx={{ width: "100%" }}
          />
          <Typography variant="caption">
            Figure {data.imageNumber[0]}: {data.imageCaption[0]}
          </Typography>
        </Box>
      )}
      {data.image.length > 1 && !isSmall && (
        <Grid2 container spacing={2} sx={{ mt: 1 }}>
          {data.image.map((image, index) => (
            <Grid2 size={6} key={image}>
              <Box
                component="img"
                src={getImageURL(image)}
                alt={data.imageCaption[index]}
                sx={{ width: "100%" }}
              />
              <Typography variant="caption" sx={{ mb: 1 }}>
                Figure {data.imageNumber[index]}: {data.imageCaption[index]}
              </Typography>
            </Grid2>
          ))}
        </Grid2>
      )}
      {isSmall && (
        <Grid2 container spacing={2} sx={{ mt: 1 }}>
          {data.image.map((image, index) => (
            <Grid2 size={3} key={image}>
              <Box
                component="img"
                src={getImageURL(data.image[index])}
                alt={data.imageCaption[index]}
                sx={{ width: "100%" }}
              />
            </Grid2>
          ))}
        </Grid2>
      )}
    </Box>
  )
}
